import React from "react";

/**
 * Logo — matches the provided image exactly:
 *  • Dark rounded-square background
 *  • Gradient border stroke: indigo (top-left) → purple → amber (top-right)
 *  • Bold white capital M centred inside
 *  • Blue < bracket on the left side, amber > bracket on the right side
 */
function Logo({ size = 40, className = "" }) {
  const id = "ml";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`nav-logo-svg ${className}`}
      aria-label="M. Muaaz logo"
      role="img"
    >
      <defs>
        {/* Main border gradient: indigo → purple → amber */}
        <linearGradient id={`${id}-g`} x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
          <stop offset="0%"   stopColor="#5b5ef4" />
          <stop offset="50%"  stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#f59e0b" />
        </linearGradient>
      </defs>

      {/* ── Rounded square background ── */}
      <rect x="4" y="4" width="92" height="92" rx="22" ry="22"
        fill="#0d0f1a"
        stroke={`url(#${id}-g)`}
        strokeWidth="3"
      />

      {/* ── Bold M, centred ── */}
      {/*
        Drawn as a filled path:
        left leg up, peak-left, valley-dip, peak-right, right leg down.
        Kept narrow so the < > brackets have room.
      */}
      <path
        d="M30,70 L30,30 L50,58 L70,30 L70,70 L64,70 L64,44 L50,66 L36,44 L36,70 Z"
        fill="white"
      />

      {/* ── < bracket (indigo/blue) ── */}
      <path
        d="M18,43 L11,50 L18,57"
        stroke="#6366f1"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* ── > bracket (amber) ── */}
      <path
        d="M82,43 L89,50 L82,57"
        stroke="#f59e0b"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Logo;
